import React from 'react';
import ReactDOM from 'react-dom/client';
import GrievanceWriteToUsApp from './GrievanceWriteToUsApp';

const ELEMENT_ID = 'scl-grievance-write-to-us';

class SCLGrievanceWriteToUsElement extends HTMLElement {
  constructor() {
    super();
    this.root = null;
  }

  connectedCallback() {
    if (this.root) return;

    const siteId =
      window.Liferay?.ThemeDisplay?.getScopeGroupId() ||
      this.getAttribute('data-site-id') ||
      '0';

    this.root = ReactDOM.createRoot(this);
    this.root.render(<GrievanceWriteToUsApp siteId={siteId} />);
  }

  disconnectedCallback() {
    this.root?.unmount();
    this.root = null;
  }
}

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, SCLGrievanceWriteToUsElement);
}

export default SCLGrievanceWriteToUsElement;
